import { createRouter, createWebHistory } from 'vue-router';
import { useAuthStore } from '@/store/auth';

import AppView from '@/views/AppView.vue'; // Import the AppView layout
import LoginView from '@/views/LoginView.vue';
import ForgotPasswordView from '@/views/ForgotPasswordView.vue';
import NotFoundView from '@/views/NotFoundView.vue';

import DashboardHome from '@/components/dashboard/DashboardHome.vue';
import SettingsHome from '@/components/settings/SettingsHome.vue';
import CarListings from '@/components/listing/cars/Cars.vue';

import Clients from '@/components/modules/clients/Clients.vue'
import Opportunities from '@/components/modules/opportunities/Opportunities.vue'

import Sales from '@/components/modules/sales/Sales.vue'
import Quotations from '@/components/modules/quotations/Quotations.vue'

import Activities from '@/components/modules/activities/Activities.vue'

import Reports from '@/components/reports/Container.vue'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: LoginView, // Login view for unauthenticated users
  },
  {
    path: '/forgot-password',
    name: 'Forgot Password',
    component: ForgotPasswordView, // Login view for unauthenticated users
  },
  {
    path: '/',
    component: AppView, // Use AppView as the layout for authenticated users
    meta: { requiresAuth: true }, // Protect all children routes
    children: [
      {
        path: '',
        name: 'Dashboard',
        component: DashboardHome,
      },
      {
        path: 'settings',
        name: 'Settings',
        component: SettingsHome,
      },
      {
        path: 'car-listings',
        name: 'Cars',
        component: CarListings,
      },
      {
        path: 'clients/:id?',
        name: 'Clients',
        component: Clients,
      },
      {
        path: 'quotations',
        name: 'Quotations',
        component: Quotations
      },
      {
        path: 'sales',
        name: 'Sales',
        component: Sales
      },
      {
        path: 'opportunities/:id?',
        name: 'Opportunities',
        component: Opportunities,
      },
      {
        path: 'reports',
        name: 'Reports',
        component: Reports,
      },

      {
        path: 'activities',
        name: 'Activities',
        component: Activities,
      },
    ],
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: NotFoundView, // Lazy-load for a 404 page
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// Navigation guard to protect routes
router.beforeEach((to, from, next) => {
  const authStore = useAuthStore();
  const isAuthenticated = authStore.isAuthenticated;

  if (to.meta.requiresAuth && !isAuthenticated) {
    next({ name: 'Login' });
  } else if (to.name === 'Login' && isAuthenticated) {
    next({ name: 'Dashboard' });
  } else {
    next();
  }
});

export default router;
